/**
 * 1등급 계정 삭제 안내 — 공개 URL (/account-deletion)
 * Google Play 데이터 보안 정책에 따른 필수 페이지.
 */
import React from 'react';
import styled from 'styled-components';

const APP_NAME = '1등급';
const DEVELOPER = '주식회사 홍컴즈';
const CONTACT = 'kkan2222@gmail.com';

const AccountDeletionPage = () => {
  return (
    <Container>
      <Top>
        <Brand>{APP_NAME}</Brand>
        <H1>계정 및 데이터 삭제 안내</H1>
        <Subtitle>운영사: {DEVELOPER}</Subtitle>
      </Top>

      <Content>
        <Lead>
          {APP_NAME} 앱 회원은 언제든지 계정과 관련 데이터의 삭제를 요청할 수 있습니다.
          아래 절차를 확인해 주세요.
        </Lead>

        <Section>
          <H2>1. 앱에서 직접 탈퇴하기</H2>
          <P>1) {APP_NAME} 앱 실행</P>
          <P>2) 하단 [내 정보] 또는 [마이페이지] 탭 이동</P>
          <P>3) [설정] → [회원 탈퇴] 메뉴 선택</P>
          <P>4) 안내에 따라 탈퇴 완료</P>
          <P>탈퇴 즉시 계정과 개인정보가 처리됩니다.</P>
        </Section>

        <Section>
          <H2>2. 앱 접근이 어려운 경우 — 이메일 요청</H2>
          <P>앱에 접근하기 어려운 경우, 아래 이메일로 직접 삭제를 요청할 수 있습니다.</P>
          <ContactBox>
            <strong>{CONTACT}</strong>
          </ContactBox>
          <P>요청 시 다음 정보를 함께 보내주세요.</P>
          <P>· 가입 시 사용한 이메일 또는 휴대전화번호</P>
          <P>· 소셜 로그인 종류 (카카오 / 구글)</P>
          <P>· 요청 사유 (선택)</P>
          <P>접수 후 영업일 기준 3일 이내에 처리하며, 처리 결과는 동일 이메일로 회신합니다.</P>
        </Section>

        <Section>
          <H2>3. 삭제되는 데이터</H2>
          <P>회원 탈퇴 시 다음 정보가 모두 삭제됩니다.</P>
          <P>· 계정 정보 (이름, 이메일, 휴대전화번호)</P>
          <P>· 프로필 사진 및 첨부 자료</P>
          <P>· 학원·자녀 등록 정보, 출결 기록, 성적 기록</P>
          <P>· 1:1 채팅·메시지 기록</P>
          <P>· 푸시 알림 토큰(FCM)</P>
          <P>· 위치 권한 동의 기록</P>
        </Section>

        <Section>
          <H2>4. 일정 기간 보관되는 데이터</H2>
          <P>관련 법령에 따라 아래 정보는 즉시 삭제되지 않고 일정 기간 보관 후 파기됩니다.</P>
          <P>· 계약 또는 청약철회 등에 관한 기록: <strong>5년</strong> (전자상거래법)</P>
          <P>· 대금결제 및 재화 등의 공급에 관한 기록: <strong>5년</strong> (전자상거래법)</P>
          <P>· 소비자의 불만 또는 분쟁처리에 관한 기록: <strong>3년</strong> (전자상거래법)</P>
          <P>· 접속 로그·접속 IP 기록: <strong>3개월</strong> (통신비밀보호법)</P>
          <P>위 보관 기간 종료 후에는 복구 불가능한 방식으로 영구 삭제됩니다.</P>
        </Section>

        <Section>
          <H2>5. 학원이 보관 중인 학생·자녀 정보</H2>
          <P>
            학원 회원이 운영 목적으로 보관 중인 학부모·학생 정보는, 해당 학원이 「개인정보 보호법」상 처리자로서
            관리합니다. 학원 단위 정보 삭제는 해당 학원에 직접 요청하거나, 위 이메일을 통해 회사가 안내 드립니다.
          </P>
        </Section>

        <Footer>
          <FooterText>운영사: {DEVELOPER}</FooterText>
          <FooterText>문의: {CONTACT}</FooterText>
          <FooterText>최종 업데이트: 2026년 5월 23일</FooterText>
        </Footer>
      </Content>
    </Container>
  );
};

export default AccountDeletionPage;

const Container = styled.div`
  background: #fff;
  min-height: 100vh;
  padding-bottom: 80px;
`;

const Top = styled.div`
  max-width: 720px;
  margin: 0 auto;
  padding: 36px 20px 20px;
  text-align: center;
  border-bottom: 1px solid #E5E7EB;
`;

const Brand = styled.p`
  font-size: 13px;
  font-weight: 800;
  color: #18284B;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
`;

const H1 = styled.h1`
  font-size: 22px;
  font-weight: 800;
  color: #111827;
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 13px;
  color: #6B7280;
  margin-top: 8px;
`;

const Content = styled.div`
  max-width: 720px;
  margin: 0 auto;
  padding: 22px 20px;
`;

const Lead = styled.p`
  font-size: 14px;
  line-height: 1.7;
  color: #374151;
  background: #F4F7FF;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 24px;
`;

const Section = styled.div`
  margin-bottom: 28px;
`;

const H2 = styled.h2`
  font-size: 15.5px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 10px;
`;

const P = styled.p`
  font-size: 13.5px;
  color: #374151;
  line-height: 1.85;
  word-break: keep-all;
  margin-bottom: 4px;
`;

const ContactBox = styled.div`
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 12px 14px;
  margin: 10px 0;
  font-size: 14.5px;
`;

const Footer = styled.div`
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
`;

const FooterText = styled.p`
  font-size: 12.5px;
  color: #6B7280;
  line-height: 1.7;
`;
